import { React, useEffect } from "react";
import {
  RightLayoutContainer,
  PageTitleComp,
  ContentMiddle,
} from "../../styledElements";
import { Button, PageHeader } from "antd";
import Iconmoon from "../../../Components/IconsFiles/icon";
import { useLocation, useNavigate } from "react-router-dom";
import LottieAnimation from "../../../Lottie";
import JobcardPrepare from "../../../Components/IconsFiles/preparing_job_card";
import { uploadProducts } from "../../../Services/uploadServices";
import axios from "axios";

const PreparingUploadProduct = (props) => {
  const history = useNavigate();
  const location = useLocation();
  const source = axios.CancelToken.source();

  useEffect( () => {
    ( async () => {
    let body = {
      bucket_key: location.state.action,
    }

    await uploadProducts(body,source)
      .then((response) => {
        if(response?.data?.products?.length == 0){
          history("../products-records/upload-products", {
            state: { isFileEmpty: true, msg: "NO DATA", fileEmptyKey: "no data"}
          })
        } else{
          history("../products-records/validate-products", {
            state: { action: response,filename:location.state.action }
          })
        }
      })
      .catch((error) => {
        history("../products-records/upload-products", {
          state: { error: true }
        })
      });
    })();
  }, [])

  useEffect(() => {
    return()=>{
      source.cancel("Page is redirected")
    }
  },[])

  return (
    <RightLayoutContainer>
      <PageTitleComp style={{ borderBottom: "0" }}>
        <PageHeader
          ghost={false}
          title="Upload Products"
          extra={[
            <Button key="1" className="textTypeBtn textBtnIcon" onClick={() => { history("../products-records/upload-products") }}>
              {" "}
              <Iconmoon
                icon="wrong"
                size={14}
                color="#EA4E2C"
                style={{ marginRight: "8px", top: "1px", position: "relative" }}
              />{" "}
              Cancel Upload
            </Button>,
          ]}
        ></PageHeader>
      </PageTitleComp>
      <ContentMiddle>
        <div className="imageAnimate">
          <div className="imageCover">
            <LottieAnimation lotti={JobcardPrepare} />

            <p>
              We are uploading your products, <br />
              please wait, it will take less than a minute
            </p>
          </div>
        </div>
      </ContentMiddle>
    </RightLayoutContainer>
  );
};

export default PreparingUploadProduct;
